import { render, staticRenderFns } from "./Directory.vue?vue&type=template&id=e0fafe22&scoped=true&"
import script from "./Directory.vue?vue&type=script&lang=ts&"
export * from "./Directory.vue?vue&type=script&lang=ts&"
import style0 from "./Directory.vue?vue&type=style&index=0&id=e0fafe22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fafe22",
  null
  
)

export default component.exports